import { toast } from '../../stores/uiStore'

/**
 * Alıntılanan mesaja kaydır ve kısa süre vurgula.
 *
 * Neden ortak dosya: aynı davranış hem kanal akışında (ChatPage) hem konu
 * panelinde (ThreadPanel → /chat, yüzen pencere, belge görüşmesi) gerekiyor.
 * İki yerde ayrı yazılsaydı biri düzeltilip diğeri unutulurdu.
 *
 * Arama `document` genelinde yapılır: alıntılanan mesaj konu panelinde de
 * kanal akışında da olabilir; ikisi de aynı `data-mid` işaretini taşır.
 */
export function jumpToMessage(id) {
  if (!id) return false
  const node = document.querySelector(`[data-mid="${id}"]`)
  if (!node) {
    // Sessiz kalma: kullanıcı tıkladı, bir şey olmadıysa sebebini bilmeli.
    toast.info('Mesaj yüklenmedi', 'Yukarı kaydırıp tekrar dene')
    return false
  }
  node.scrollIntoView({ behavior: 'smooth', block: 'center' })
  node.classList.add('ring-2', 'ring-primary-300', 'bg-primary-50/60')
  setTimeout(() => node.classList.remove('ring-2', 'ring-primary-300', 'bg-primary-50/60'), 1400)
  return true
}
